
import Vue from "vue";

export default Vue.extend({
  name: "BreadcrumbItem",
  props: {
    href: String,
  },
});
